import { render, staticRenderFns } from "./FolderCheckItem.vue?vue&type=template&id=09705281&scoped=true&"
import script from "./FolderCheckItem.vue?vue&type=script&lang=js&"
export * from "./FolderCheckItem.vue?vue&type=script&lang=js&"
import style0 from "./FolderCheckItem.vue?vue&type=style&index=0&id=09705281&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09705281",
  null
  
)

export default component.exports